import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'common-ui-components/dist/components/Atoms/Modal';
import Button from 'common-ui-components/dist/components/Atoms/Button';
import Notification from 'common-ui-components/dist/components/Atoms/Notification';

const BogoCreateQuoteModal = props => {
  const { unavailableIconUrl, labels, bogoQuoteModalStatus, setBogoQuoteModalStatus } = props;
  const { bogoQuoteModalHeading, bogoQuoteModalBodyText, bogoQuoteModalButtonText } = labels;

  const modalHeading = () => (
    <Notification title={bogoQuoteModalHeading} icon={unavailableIconUrl} />
  );

  const modalProps = {
    className: 'modal_Content',
    elementLocator: 'bogo-quote-modal',
    isOpen: bogoQuoteModalStatus,
    shouldCloseOnOverlayClick: true,
    heading: modalHeading(),
    onRequestClose: () => setBogoQuoteModalStatus(false),
  };

  const modalButtonProps = {
    className: 'primary bogo-quote-modal-button',
    elementLocator: 'bogo-quote-modal-button',
    onClick: () => setBogoQuoteModalStatus(false),
  };

  return (
    <Modal {...modalProps}>
      <>
        <div className="bogo-quote-modal-message" data-locator="bogo-quote-modal-message">
          {bogoQuoteModalBodyText}
        </div>
        <div className="center-xs">
          <Button {...modalButtonProps}>{bogoQuoteModalButtonText}</Button>
        </div>
      </>
    </Modal>
  );
};

BogoCreateQuoteModal.propTypes = {
  unavailableIconUrl: PropTypes.string,
  labels: PropTypes.shape({
    bogoQuoteModalHeading: PropTypes.string,
    bogoQuoteModalBodyText: PropTypes.string,
    bogoQuoteModalButtonText: PropTypes.string,
  }),
  bogoQuoteModalStatus: PropTypes.bool,
  setBogoQuoteModalStatus: PropTypes.func,
};

BogoCreateQuoteModal.defaultProps = {
  unavailableIconUrl: '',
  labels: {},
  bogoQuoteModalStatus: false,
  setBogoQuoteModalStatus: () => {
    /* default setBogoQuoteModalStatus handler */
  },
};

export default BogoCreateQuoteModal;
